import { showNotification } from "@mantine/notifications";
import { IconX, IconCheck } from "@tabler/icons-react";
import { LoDashStatic } from "lodash";

type NotificationReturnType = {
  title: string;
  autoClose?: number | boolean | undefined;
  message?: string;
};

const useNotification = () => {
  const notification = {
    error: ({ title, message, autoClose }: NotificationReturnType) =>
      showNotification({
        title,
        message,
        color: "red",
        icon: <IconX />,
        autoClose: autoClose ?? 2000,
      }),
    success: ({ title, message, autoClose }: NotificationReturnType) =>
      showNotification({
        title,
        message,
        color: "green",
        icon: <IconCheck />,
        autoClose: autoClose ?? 2000,
      }),
    primary: ({ title, message, autoClose }: NotificationReturnType) =>
      showNotification({
        title,
        message,
        autoClose: autoClose ?? 2000,
      }),
  };
  return {
    notification,
  };
};

export default useNotification;
